import { AuthState, } from './AuthData.js';
/**
 * @internal
 */
export const NOT_LOGGED_IN = {
    state: AuthState.NotLoggedIn,
    user: undefined,
    auth: undefined,
    login: () => Promise.reject(new Error('uninitialized')),
    logout: () => Promise.reject(new Error('uninitialized')),
    renew: () => Promise.reject(new Error('uninitialized')),
};
/**
 * @internal
 */
export const LOADING = Object.assign(Object.assign({}, NOT_LOGGED_IN), { state: AuthState.Loading });
/**
 * use with `<AuthContext.Provider value={x} />`
 */
export const MOCK_NOT_LOGGED_IN = NOT_LOGGED_IN;
export const MOCK_LOADING = LOADING;
export const MOCK_LOGGED_IN = {
    state: AuthState.LoggedIn,
    user: {
        id: 'bd5c0d60-593d-4b41-9d22-cce69ff44007',
        name: 'Christophe',
        preferredUsername: 'thechristophe',
        email: undefined,
        emailVerified: undefined,
        roles: undefined,
        permissions: undefined,
        //discordId: undefined,
        //discordHandle: undefined,
        vrchatId: undefined,
        vrchatDisplayName: undefined,
        vrchatIsAgeGatedInstancesJoinable: undefined,
        system_roles: undefined,
    },
    auth: {
        token: '078486f7-f12e-4244-9e13-43bc8bc1aff7',
    },
    login: () => Promise.reject(new Error('uninitialized')),
    logout: () => Promise.reject(new Error('uninitialized')),
    renew: () => Promise.reject(new Error('uninitialized')),
};
export const MOCK_ERROR = Object.assign(Object.assign({}, MOCK_NOT_LOGGED_IN), { state: AuthState.Error });
//# sourceMappingURL=mockData.js.map